const PIXEL_ID = '2092944278169978'

declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
  }
}

let initialized = false

export function initPixel() {
  if (initialized) return
  initialized = true

  /* Meta Pixel base code */
  const f = window as Window
  const n = (f.fbq = function (...args: unknown[]) {
    if ((n as any).callMethod) {
      ;(n as any).callMethod.apply(n, args)
    } else {
      ;(n as any).queue.push(args)
    }
  })
  if (!f._fbq) f._fbq = n
  ;(n as any).push = n
  ;(n as any).loaded = true
  ;(n as any).version = '2.0'
  ;(n as any).queue = []

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = document.getElementsByTagName('script')[0]
  firstScript?.parentNode?.insertBefore(script, firstScript)

  window.fbq('init', PIXEL_ID)
}

export function trackPageView() {
  if (window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackAddToCart() {
  if (window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Mente en Calma',
      content_type: 'product',
      value: 17,
      currency: 'USD',
    })
  }
}
